import {RowNode} from './AgGridTypes';

export type RowGetter = (params: RowGetterParams) => Promise<void>;

export type SuccessParams = {
  // any here to match ag-grids row getter params
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rowData: any[];
  rowCount?: number;
};

export type RowGetterParams = {
  startRow: number;
  endRow: number;
  success(params: SuccessParams): void;
  fail(): void;
  parentNode?: RowNode;
  // any here to match ag-grids row getter params
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortModel: any;
  // any here to match ag-grids row getter params
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterModel: any;
};
